export const TitleUnderline = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="112"
    height="7"
    viewBox="0 0 112 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.000325161 0.5C0.000248787 3.25751 -0.000439867 4.41705 0.000376989 6.49999H102.338C104.251 6.50264 106.135 5.95603 107.821 4.90901C109.507 3.86199 110.943 2.34719 112 0.5H0.000325161Z"
      fill="#93D500"
    />
  </svg>
);
